import { loadSettings } from 'loaders/settings'
import type { Settings } from 'shared/types'

class SettingsSingleton {
  private static instance: SettingsSingleton

  private settings: Settings | undefined

  private loadingPromise: Promise<Settings | undefined> | null = null

  public static getInstance(): SettingsSingleton {
    if (!SettingsSingleton.instance) {
      SettingsSingleton.instance = new SettingsSingleton()
    }
    return SettingsSingleton.instance
  }

  public async getSettings(client?: any): Promise<Settings | undefined> {
    if (this.settings) {
      return this.settings
    }
    if (!this.loadingPromise && client) {
      this.loadingPromise = (async () => {
        try {
          const settings = await loadSettings(client)()
          this.settings = settings
          this.loadingPromise = null
          return settings
        } catch (error) {
          this.loadingPromise = null
          throw error
        }
      })()
    }
    return this.loadingPromise ?? Promise.resolve(undefined)
  }

  public updateSettings(settings: Partial<Settings>): void {
    if (this.settings) this.settings = { ...this.settings, ...settings }
  }
}

export default SettingsSingleton
